import type { InjectionKey } from 'vue'

export const FORM_ITEM_INJECTION_KEY: InjectionKey<string> = Symbol('form-item')
